import { Box, Colors, Modal, Text } from '@fozito/common-ui';
import { Form, Input, InputRef } from 'antd';
import FormItemValue from 'components/FormItemValue';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import { IUISelectItem } from '../cashier.interface';
import ModalActions from '../components/ModalActions';
import { NumberPadIntV2 } from '../components/NumberPad';
import { calcDiscountForItem } from '../cashier.utils';
import { formatCurrency } from 'utils/formatCurrency';
const FormStyled = styled(Form)``;
type Props = {};
type Ref = {
  open: (data: IUISelectItem, callback: (data: IUISelectItem, quantity: number) => void) => void;
};
export const globalModalUpdateQuantityRef = React.createRef<Ref>();
const ModalUpdateQuantity = forwardRef<Ref, Props>(({ }, ref) => {
  const inputRef = useRef<InputRef>(null);
  const [form] = Form.useForm();
  const [detail, setOpen] = useState<IUISelectItem | null>(null);
  const callbackRef = useRef<(data: IUISelectItem, quantity: number) => void>(() => undefined);

  const onClose = () => setOpen(null);
  const onOpen: Ref['open'] = (data, _callback) => {
    form.resetFields();
    setOpen(data);
    form.setFieldsValue(data);
    callbackRef.current = _callback || (() => undefined);
  };
  const handleFinish = (values: any) => {
    const data = values as IUISelectItem;
    callbackRef.current(data, data.quantity);
    onClose();
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
  }));

  return (
    <Modal onCancel={onClose} onOk={() => form.submit()} title='update quantity' open={!!detail} onClose={onClose} width={900}>
      <FormStyled form={form} onFinish={handleFinish}>
        <Form.Item name={'itemId'} noStyle />
        <TopInfo>
          <Box display='flex' alignItems='center' gap={'4px'}>
            <Text title_h4_24_regular color_text_3>Product name:</Text>
            <FormItemValue name={'itemName'} render={val => <Text title_h5_24_semibold>{val}</Text>} />
          </Box>
          <Box display='flex' alignItems='center' gap={'8px'}>
            <Text title_h4_24_regular color_text_3>Price:</Text>
            <FormItemValue name={'price'} render={price => {
              const discount = detail ? calcDiscountForItem(detail) : 0;
              const amountFinal = price - discount;
              if (discount) return (
                <Price title_h5_24_semibold>
                  <Discount title_h5_24_semibold>{formatCurrency(price)}</Discount>
                  {formatCurrency(amountFinal > 0 ? amountFinal : 0)}
                </Price>
              );

              return (
                <Price title_h5_24_semibold>
                  {formatCurrency(price > 0 ? price : 0)}
                </Price>
              );
            }} />
          </Box>
        </TopInfo>

        <Form.Item name={'itemType'} noStyle />
        <Form.Item name={'price'} noStyle />
        <Form.Item name={'discount'} noStyle />
        <Box display='flex' flexDirection='column' gap={8} padding={16}>
          <Text content_content_2_16_medium color_text_3 text_center style={{ fontSize: 20 }}>
            Enter Quantity
          </Text>
          <Form.Item name={'quantity'} noStyle>
            <InputKB
              ref={inputRef}
              inputMode='none'
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Box>
        <Form.Item name={'quantity'} noStyle>
          <NumberPadIntV2
            controlRef={inputRef}
          />
        </Form.Item>
        <ModalActions onClose={onClose} />
      </FormStyled>
    </Modal>
  );
});
ModalUpdateQuantity.displayName = 'ModalUpdateQuantity';
export default ModalUpdateQuantity;
const InputKB = styled(Input)`
  font-size: 60px;
  font-weight: 600;
  text-align: center;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
`;
const TopInfo = styled.div`
  display: flex;
  padding: 24px 40px 16px 40px;
  justify-content: center;
  align-items: center;
  gap: 56px;
  align-self: stretch;
  border-bottom: 1px solid #CCD4DC;
  background: #FFF;
`;
const Price = styled(Text)`
  text-align: right;
  color: ${Colors.neutral.text[5]};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: right ;
  gap: 8px;
  padding-right: 8px;
`;
const Discount = styled(Text)`
  min-width: 80px;
  text-align: right;
  color: ${Colors.primary[6]};
  text-decoration: line-through;
  font-weight: 600;
`;